function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m82.214844 211h8.785156v166.039062c-18.203125 13.699219-30 35.476563-30 59.960938 0 41.355469 33.644531 75 75 75s75-33.644531 75-75c0-24.484375-11.796875-46.261719-30-59.960938v-166.039062h8.785156l30 30h52.214844v-241h-272v241h52.214844zm53.785156 271c-24.8125 0-45-20.1875-45-45s20.1875-45 45-45 45 20.1875 45 45-20.1875 45-45 45zm15-118.492188c-4.847656-.988281-9.863281-1.507812-15-1.507812s-10.152344.519531-15 1.507812v-152.507812h30zm91-333.507812v31h-212v-31zm-212 181v-120h212v120h-9.785156l-30-30h-132.429688l-30 30zm0 0",
  strokeWidth: 12.5,
  stroke: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m61 121h150v30h-150zm0 0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m407 512c24.8125 0 45-20.1875 45-45v-15h30v-120h30v-121h-31.980469l-30-211h-86.039062l-29.996094 211h-31.984375v121h30v120h30v15c0 24.8125 20.1875 45 45 45zm15-45c0 8.269531-6.730469 15-15 15s-15-6.730469-15-15v-15h30zm-60-45v-30h90v30zm120-120h-150v-61h150zm-91.980469-272h33.960938l25.738281 181h-85.4375zm61.980469 302v30h-90v-30zm0 0",
  strokeWidth: 12.5,
  stroke: "white"
});

var SvgSpareParts = function SvgSpareParts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpareParts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spareParts.d95e4560.svg";
export { ForwardRef as ReactComponent };